import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { PasModule } from '@ddt-web/pas';
import { WealthWebModule } from '@ddt-web/wealth-web';

import { PasApiProcessingService } from './services/api-processing/pas-api-processing.service';
import { PasTransientApiProcessingService } from './services/api-processing/pas-transient-api-processing.service';
import { PasCorrelationMatrixDataLoaderService } from './services/pas-correlation-matrix-data-loader.service';
import { PasDataLoaderService } from './services/pas-data-loader.service';
import { PasDataPortfolioAnalysisService } from './services/pas-data-portfolio-analysis.service';
import { PasRiskProxyDataLoaderService } from './services/pas-risk-proxy-data-loader.service';
import { PasBlkIdeasAnalyticsProcessingService } from './services/post-processing/pas-blk-ideas-analytics-processing.service';
import { PasPartialSecurityFailingProcessingService } from './services/post-processing/pas-partial-security-failing-processing.service';
import { PasPositionDetailsLoadedProcessingService } from './services/post-processing/pas-position-actions-processing.service';
import { PasPositionDetailsPerHoldingProcessingService } from './services/post-processing/pas-position-per-holdings-actions-processing.service';
import { PasProxyProcessingService } from './services/post-processing/pas-proxy-processing.service';
import { PasResponseProcessingService } from './services/response-processing/pas-response-processing.service';
import { PasTransientResponseProcessingService } from './services/response-processing/pas-transient-response-processing.service';
@NgModule({
	// eslint-disable-next-line
	imports: [CommonModule, WealthWebModule, PasModule]
})
export class PasSetupDataWorkersModule {
	public static forRoot(): ModuleWithProviders<PasSetupDataWorkersModule> {
		return {
			ngModule: PasSetupDataWorkersModule,
			providers: [
				PasDataLoaderService,
				PasDataPortfolioAnalysisService,
				PasApiProcessingService,
				PasTransientApiProcessingService,
				PasProxyProcessingService,
				PasResponseProcessingService,
				PasTransientResponseProcessingService,
				PasPositionDetailsLoadedProcessingService,
				PasCorrelationMatrixDataLoaderService,
				PasRiskProxyDataLoaderService,
				PasPositionDetailsPerHoldingProcessingService,
				PasPartialSecurityFailingProcessingService,
				PasBlkIdeasAnalyticsProcessingService
			]
		};
	}
}
